import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';

// Styles
import styles from './index.module.sass';

export default function AddresDetail({ history, match, getOrder, orderData, device, loading }) {
  const { t } = useTranslation('address');
  const screenSize = device?.screenSize || 'desktop';

  function handleClick(route) {
    history.push(route);
  }

  useEffect(() => {
    getOrder('CERRAR01', '', '', '', '', true);
  }, [getOrder]);

  return (
    <div className={`${styles.addresDetail} ${styles[screenSize]}`}>
      {(loading && <CircularProgress className={styles.circularProgress} />) || (
        <>
          <div className={styles.top}>
            <div className={styles.title}>{t('addresTitle')}</div>
            <div className={styles.addressData}>
              <span className={styles.name}>{t('name')}:</span>
              <span className={styles.text}>{orderData?.cliente?.nombreCompleto || ''}</span>
            </div>
          </div>

          <div className={styles.middle}>
            <div className={styles.column}>
              <div className={styles.addresTitle}>{t('clientData')}:</div>
              <div className={styles.addressData}>
                <span className={styles.name}>{t('name')}:</span>
                <span className={styles.text}>{orderData?.cliente?.nombreCompleto || ''}</span>
              </div>
              <div className={styles.addressData}>
                <span className={styles.name}>{t('street')}:</span>
                <span className={styles.text}>{orderData?.cliente?.calle || ''}</span>
              </div>
              <div className={styles.addressData}>
                <span className={styles.name}>{t('postalCode')}:</span>
                <span className={styles.text}>{orderData?.cliente?.cp || ''}</span>
              </div>
              <div className={styles.addressData}>
                <span className={styles.name}>{t('state')}:</span>
                <span className={styles.text}>{orderData?.cliente?.estado || ''}</span>
              </div>
            </div>

            <div className={styles.column}>
              <div className={styles.addresTitle}>{t('shippingInformation')}:</div>
              <div className={styles.addressData}>
                <span className={styles.name}>{t('name')}:</span>
                <span className={styles.text}>{orderData?.domicilioEnvio?.nombre || ''}</span>
              </div>
              <div className={styles.addressData}>
                <span className={styles.name}>{t('street')}:</span>
                <span className={styles.text}>{orderData?.domicilioEnvio?.calle || ''}</span>
              </div>
              <div className={styles.addressData}>
                <span className={styles.name}>{t('postalCode')}:</span>
                <span className={styles.text}>{orderData?.domicilioEnvio?.cp || ''}</span>
              </div>
              <div className={styles.addressData}>
                <span className={styles.name}>{t('state')}:</span>
                <span className={styles.text}>{orderData?.domicilioEnvio?.estado || ''}</span>
              </div>
              <div className={styles.accionButtons}>
                <Button
                  type='submit'
                  variant='contained'
                  size='large'
                  color='primary'
                  className={styles.actionButton}
                  onClick={() => handleClick(`${match.path}/form`)}>
                  {t('changeAddress')}
                </Button>
              </div>
            </div>
          </div>

          <div className={styles.footer}>
            <div className={styles.back}>
              <span onClick={() => handleClick('/cart/order')}>{t('back')}</span>
            </div>
            <div className={styles.closeOrder}>
              <Button
                type='submit'
                variant='contained'
                size='large'
                color='primary'
                className={styles.closeOrderButton}>
                {t('closeOrder')}
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
